import { lazy, Suspense } from "react";

import CodeEditorLoadingSkeleton from "components/CodeEditor/LoadingSkeleton";

import { YamlCodeEditorMonacoProps } from "./Monaco";

type YamlCodeEditorProps = YamlCodeEditorMonacoProps;

const LazyYamlCodeEditorMonaco = lazy(() => import("./Monaco"));

const YamlCodeEditor = (props: YamlCodeEditorProps) => {
  return (
    <Suspense fallback={<CodeEditorLoadingSkeleton skeletonCount={props.skeletonCount} />}>
      <LazyYamlCodeEditorMonaco {...props} />
    </Suspense>
  );
};

export default YamlCodeEditor;
